import { getCostCenters } from '@api/cost-centers';
import { useQuery } from '@tanstack/react-query';

export const useGetCostCenters = (params?: { disable?: boolean }) => {
  const { data: costCenters = [], isFetching } = useQuery({
    queryFn: () => getCostCenters(),
    queryKey: ['costCenters'],
    enabled: !params?.disable,
    initialData: [],
  });

  // Use default cost center. If user has no access to default cost center use first cost center on the list
  const defaultCostCenter =
    costCenters.find((costCenter) => costCenter.defaultCostCenter) || costCenters[0];

  // Use automatic assignment cost center. If user has no access to automatic assignment cost center use default cost center
  const automaticAssignmentCostCenter =
    costCenters.find((costCenter) => costCenter.automaticAssignment) || defaultCostCenter;

  const costCentersOptions = costCenters.map((costCenter) => ({
    label: costCenter.name,
    value: costCenter.id,
  }));

  const getCostCenterName = (id: string) => {
    return costCenters.find((costCenter) => costCenter.id === id)?.name;
  };

  return {
    automaticAssignmentCostCenter,
    costCentersOptions,
    getCostCenterName,
    defaultCostCenter,
    costCenters,
    isFetching,
  };
};
